import RestAPIClient from "./RestAPIClient";
import { IProgram, IRequestPrograms, IRequestGetLink, IResponseGetLink } from "./typings/program";

class reportService extends RestAPIClient {
  constructor() {
    super("tiki");
  }

  getPrograms = async (req: IRequestPrograms): Promise<IProgram[]> => {
    const { order, sort_by } = req;
    const res = await this.get(`/programs?sort_by=${sort_by}&order=${order}`);
    return res.data;
  };

  getProgram = async (id: string): Promise<IProgram> => {
    const res = await this.get(`/programs/${id}`);
    return res.data;
  };

  getLink = async (req: IRequestGetLink): Promise<IResponseGetLink> => {
    const res = await this.post(`/link`, req);
    return res.data;
  }
}

export default new reportService();
